import { withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ref, watch } from 'vue'

import FormSection from '@/components/neue/FormSection.vue'
import FormElement from '@/components/neue/FormElement.vue'
import InputField from '@/components/neue/InputField.vue'
import SelectInput from '@/components/neue/SelectInput.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import TheModal from '@/components/TheModal.vue'
import api from '@/store/api'
import { useToast } from '@/composables/useToast'


export default {
  __name: 'SystemUserModal',
  props: {
  isOpen: {
    type: Boolean,
    required: true
  },
  user: {
    type: Object,
    required: true,
    default: () => ({
      id: null,
      full_name: '',
      email: '',
      roleId: null,
      originalFullName: '',
      originalEmail: '',
      originalRoleId: null
    })
  },
  roles: {
    type: Array,
    default: () => []
  },
  fixedRoleId: {
    type: [String, Number],
    default: null
  }
},
  emits: ['close', 'save'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const { showToast } = useToast()
const isResettingPassword = ref(false)
const passwordResetSent = ref(false)

// Reset password reset state when user changes or modal closes
watch(
  () => [props.user.id, props.isOpen],
  ([newUserId, isOpen]) => {
    if (!isOpen || !newUserId) {
      passwordResetSent.value = false
    }
  }
)

const hasChanges = computed(() => {
  if (!props.user.id) return false
  return (
    props.user.full_name !== props.user.originalFullName ||
    props.user.email !== props.user.originalEmail ||
    props.user.roleId !== props.user.originalRoleId
  )
})

const stripEmailBlanks = email => (email || '').replace(/\s/g, '')

const handleSave = () => {
  const email = stripEmailBlanks(props.user.email)
  if (!props.user.full_name || !email) return
  if (props.roles.length && !props.user.roleId) return
  emit('save', { ...props.user, email })
}

const handlePasswordReset = async () => {
  if (!props.user.id || isResettingPassword.value || passwordResetSent.value) return

  isResettingPassword.value = true

  try {
    await api.call('PATCH', `system_users/${props.user.id}`, {
      system_user: {
        system_user_tokens_attributes: [
          {
            type: 'PasswordResetSystemUserToken'
          }
        ]
      }
    })

    passwordResetSent.value = true
    showToast('Password reset email sent successfully', { type: 'success' })
  } catch (error) {
    console.error('Error sending password reset:', error)
    showToast('Failed to send password reset email', { type: 'error' })
  } finally {
    isResettingPassword.value = false
  }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(TheModal, {
    "is-open": __props.isOpen,
    "modal-title": __props.user.id ? 'Edit system user' : 'Add system user',
    "modal-description": __props.user.id ? '' : 'Once added we will notify the user via email with password setup instructions.',
    onCloseModal: _cache[3] || (_cache[3] = $event => (_ctx.$emit('close')))
  }, {
    main: _withCtx(() => [
      _createVNode(FormSection, null, {
        default: _withCtx(() => [
          _createVNode(FormElement, null, {
            default: _withCtx(() => [
              _createVNode(InputField, {
                name: "Full Name",
                modelValue: __props.user.full_name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((__props.user.full_name) = $event)),
                onKeyup: _withKeys(handleSave, ["enter"])
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(FormElement, null, {
            default: _withCtx(() => [
              _createVNode(InputField, {
                name: "Email",
                modelValue: __props.user.email,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((__props.user.email) = $event)),
                onKeyup: _withKeys(handleSave, ["enter"])
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      (__props.user.id)
        ? (_openBlock(), _createBlock(NeueButton, {
            key: 0,
            type: "secondary",
            onClick: handlePasswordReset,
            disabled: isResettingPassword.value || passwordResetSent.value,
            class: "mr-auto"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(isResettingPassword.value ? 'Sending...' : passwordResetSent.value ? 'Password reset sent' : 'Send password reset'), 1)
            ]),
            _: 1
          }, 8, ["disabled"]))
        : _createCommentVNode("", true),
      _createVNode(NeueButton, {
        type: "secondary",
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode("Cancel", -1)
        ]))]),
        _: 1
      }),
      _createVNode(NeueButton, {
        type: __props.user.full_name && __props.user.email && (!__props.roles.length || __props.user.roleId) ? 'primary' : 'inactive',
        onClick: handleSave
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.user.id ? (hasChanges.value ? 'Save' : 'Done') : 'Add'), 1)
        ]),
        _: 1
      }, 8, ["type"])
    ]),
    _: 1
  }, 8, ["is-open", "modal-title", "modal-description"]))
}
}

}